const STYLES = {
  open: "border-[hsl(var(--status-customer-verified))]/40 bg-[hsl(var(--status-customer-verified))]/10 text-[hsl(var(--status-customer-verified))]",
  in_progress: "border-[hsl(var(--status-mismatch))]/40 bg-[hsl(var(--status-mismatch))]/10 text-[hsl(var(--status-mismatch))]",
  resolved: "border-[hsl(var(--status-verified))]/40 bg-[hsl(var(--status-verified))]/10 text-[hsl(var(--status-verified))]",
  closed: "border-border bg-secondary text-muted-foreground",
};

export const TicketStatusBadge = ({ status }) => (
  <span
    data-testid={`ticket-status-badge-${status}`}
    className={`inline-flex shrink-0 items-center whitespace-nowrap rounded border px-1.5 py-0.5 text-[10px] font-medium uppercase tracking-wide ${
      STYLES[status] || STYLES.closed
    }`}
  >
    {String(status || "").replace("_", " ")}
  </span>
);
